export default {
    default: [25, 18, 15, 12, 10, 8, 6, 4, 2, 1],
    distance25: [6, 4, 3, 2, 1],
    distance50: [13, 10, 8, 6, 5, 4, 3, 2, 1],
    distance75: [19, 15, 12, 9, 8, 6, 5, 3, 2, 1],
    sprint: [8, 7, 6, 5, 4, 3, 2, 1],
}
